/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetToolMetadataRequestBody,
  SetToolMetadataRequestBody$Outbound,
  SetToolMetadataRequestBody$outboundSchema,
} from "../components/settoolmetadatarequestbody.js";

export type SetMcpServerToolMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetMcpServerToolMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetMcpServerToolMetadataSecurity = {
  option1?: SetMcpServerToolMetadataSecurityOption1 | undefined;
  option2?: SetMcpServerToolMetadataSecurityOption2 | undefined;
};

export type SetMcpServerToolMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setToolMetadataRequestBody: SetToolMetadataRequestBody;
};

/** @internal */
export type SetMcpServerToolMetadataSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetMcpServerToolMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetMcpServerToolMetadataSecurityOption1$Outbound,
    SetMcpServerToolMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setMcpServerToolMetadataSecurityOption1ToJSON(
  setMcpServerToolMetadataSecurityOption1:
    SetMcpServerToolMetadataSecurityOption1,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataSecurityOption1$outboundSchema.parse(
      setMcpServerToolMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetMcpServerToolMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetMcpServerToolMetadataSecurityOption2$Outbound,
    SetMcpServerToolMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setMcpServerToolMetadataSecurityOption2ToJSON(
  setMcpServerToolMetadataSecurityOption2:
    SetMcpServerToolMetadataSecurityOption2,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataSecurityOption2$outboundSchema.parse(
      setMcpServerToolMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataSecurity$Outbound = {
  Option1?: SetMcpServerToolMetadataSecurityOption1$Outbound | undefined;
  Option2?: SetMcpServerToolMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetMcpServerToolMetadataSecurity$outboundSchema: z.ZodMiniType<
  SetMcpServerToolMetadataSecurity$Outbound,
  SetMcpServerToolMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetMcpServerToolMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetMcpServerToolMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setMcpServerToolMetadataSecurityToJSON(
  setMcpServerToolMetadataSecurity: SetMcpServerToolMetadataSecurity,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataSecurity$outboundSchema.parse(
      setMcpServerToolMetadataSecurity,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetToolMetadataRequestBody: SetToolMetadataRequestBody$Outbound;
};

/** @internal */
export const SetMcpServerToolMetadataRequest$outboundSchema: z.ZodMiniType<
  SetMcpServerToolMetadataRequest$Outbound,
  SetMcpServerToolMetadataRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setToolMetadataRequestBody: SetToolMetadataRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setToolMetadataRequestBody: "SetToolMetadataRequestBody",
    });
  }),
);

export function setMcpServerToolMetadataRequestToJSON(
  setMcpServerToolMetadataRequest: SetMcpServerToolMetadataRequest,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataRequest$outboundSchema.parse(
      setMcpServerToolMetadataRequest,
    ),
  );
}
